export const DAILY_INCOME="DAILY_INCOME";
export const RECENT_TRANSACTION='RECENT_TRANSACTION';
export const SHOW_TODAY_INCOME="SHOW_TODAY_INCOME"
export const TODAYINCOME_TABLE="TODAYINCOME_TABLE";
export const ALL_TRANSACTION="ALL_TRANSACTION";